// this file will be blocked when we attempt to load it if an ad blocker is present and enabled
// snippet from https://www.detectadblock.com/
const e = document.createElement('div');
e.id = 'NZDlnkaIbCOH_PANDORA';
e.style.display = 'none';
document.body.appendChild(e);
